<template>
  <div class="topcate-tab">
    <span
      @click="clickTab(item.value)"
      v-for="item in topcateList"
      :key="item.name"
      :class="
        topcate === item.value ? 'topcate-tab-item active' : 'topcate-tab-item'
      "
      >{{ item.name }}</span
    >
  </div>
</template>
<script>
export default {
  props: {
    topcate: {
      type: String,
    },
    topcateList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    clickTab(topcate) {
      this.$emit('tocateChange', topcate);
    },
  },
};
</script>
<style lang="scss" scoped>
.topcate-tab {
  display: flex;
  align-items: center;

  &-item {
    box-sizing: border-box;
    width: 68px;
    height: 28px;
    font-size: 14px;
    border: 1px solid #e9e9e9;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 14px;
    margin-right: 20px;
    font-weight: 400;
    color: #222226;
    cursor: pointer;

    &:hover {
      border: 1px solid #417ff9;
      color: #417ff9;
    }
  }

  .active {
    border: 1px solid #417ff9 !important;
    color: #417ff9 !important;
  }
}
</style>
